export enum CalCategory {
    IMPORTANT = "IMPORTANT",
    CAR = "CAR",
    INVITATION = "INVITATION",
    PERSONAL = "PERSONAL"
}
